import { cn } from '../../utils/classNames';
import { SparkleIcon } from '../../icons';

// Ported from LeadKitchen v3 src/empty.jsx.
// Presentational empty-state block with optional icon, title, desc, and actions.
export function EmptyState({
  icon: IconComp = SparkleIcon,
  title,
  desc,
  action,
  secondary,
  compact,
}) {
  return (
    <div className={cn('lk-empty', compact && 'lk-empty--compact')}>
      <div className="lk-empty__icon">
        <IconComp size={compact ? 20 : 24} stroke={1.5} />
      </div>
      <h4 className="lk-empty__title">{title}</h4>
      {desc && <div className="lk-empty__desc">{desc}</div>}
      {(action || secondary) && (
        <div className="lk-empty__actions">
          {action && (
            <button className="lk-btn lk-btn--primary lk-btn--sm" onClick={action.onClick}>
              {action.icon ? <action.icon size={13} /> : null}
              {action.label}
            </button>
          )}
          {secondary && (
            <button className="lk-btn lk-btn--ghost lk-btn--sm" onClick={secondary.onClick}>
              {secondary.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
